module.exports = __webpack_public_path__ + "static/media/menu_dashboard.fd91c338.png";